import { getBranches, getExoContext } from "@/messenger/services/data.service";
import { getDomainHost } from "@/messenger/utils/helpers";

export const getDefaultTimezone = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
};

export const getBranchIds = (branches, branch) => {
    const ids = branches?.map((ele) => {
        if(branch?.includes(ele.label)){
            return ele.id;
        }
        return false;
    }).filter((item) => !!item);
    return ids;
};

export const getBranchNames = (branches, id) => {
    const name = branches?.map((ele) => {
        if(ele.id === id){
            return ele.label;
        }
    }).filter((item) => !!item);
    return name && name[0];
};

export const getLocationId = (arr: Array<any>) => {
    if(arr.length < 1){
        return false;
    }
    const res = arr?.find((item) => {
        const type: string = item?._type;
        if(type.includes("location_id")){
            return item;
        }
    });
    return res?._key;
};


export const getExoHandler = async (type: string, key: string, relationship: string, path: string) => {
    try {
        const host = getDomainHost();
        let useKey = host;
        if (key) useKey = key;
        const res = await getExoContext(type, useKey, relationship, path);
        return res?.exo[0]?.context;
    } catch (error) {
        return [];
    }
};
export const getBranchesHandler = async () => {
    try {
        const host = getDomainHost();
        const branchData = [];
        //const res = await getBranches(host)
        const res = await getBranches(host);

        res?.info[0]?.selectable.forEach((item) => {
            const id = getLocationId(item.detail.identities);
            
            if (item.detail.names && item.detail.names) {
                item.detail.names.forEach((i) => {
                    if(i.en_US){
                        branchData.push({
                            label: i.en_US,
                            heading: i.en_US,
                            id,
                        });
                    }
                });
            } else {
                branchData.push({
                    label: item.detail.name,
                    heading: item.detail.name,
                    id,
                });
            }
        });

        return branchData;
    } catch (error) {
        return [];
    }
};
